import React from 'react'
import { seasonalHelpers } from './seasonalHelpers'
import { seasonalDataHelpers, seasonalUpdateTypes } from './seasonalDataHelpers'
import { sportAccessTypes } from '../SportsSidebarReducer'

const saveSportsDataToDatabase = (database_fns, pathViews, state, callback, allRosters) => {

  const _seasonalDataHelpers = seasonalDataHelpers(database_fns, pathViews)

  const {
    collectionName,
    current_accessOrGls,
    currentMenuKey,
    formData,
    glsScores,
    glsTeams,
    selectedSeason,
    sheetsData,
    sportAccessType,
    sportPermissions,
    sportsDataMode,
    sportsKey,
    teamRosters,
    tournamentResults,
    _sportsYearAbr,
    teams,
    parentDataKeys
  } = state

  const { schoolsContacts, districtContacts } = sheetsData ?? {}

  const sportsMode = {
    organization: pathViews && pathViews.organizations && !pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    district: pathViews && pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    school: pathViews && pathViews.schools ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: false,
  }

  const cb = () => {
    console.log('cb!!!')
    // I@gtcmhc@2026!
    callback()
  }

  let _updateData;
  let _pks;

  // database_fns, sportPermissions, pathViews, pks, callback, collectionName, documentFieldName, data, opts, dataInfos, _sportsYearAbr
  const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, null, cb, null, null, null, { ignoreSeason: true })

  switch (sportsDataMode) {

    case _sdm.district.glsScores:
      _updateData = { glsScores: glsScores }
      _pks = seasonalHelpers.getPks(pathViews)
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case _sdm.district.contactsDistrict:
      _updateData = { districts: districtContacts }
      _pks = seasonalHelpers.getPks(pathViews)
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case _sdm.district.contactsSchools:
      _updateData = { schools: schoolsContacts }
      _pks = seasonalHelpers.getPks(pathViews, null, null, ['schools'])
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case _sdm.district.accessSports:
      _updateData = { sports: current_accessOrGls }
      _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports'])
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case _sdm.sports.accessTeams:
      _updateData = { teams: current_accessOrGls }
      _pks = seasonalHelpers.getPks(pathViews)
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectiofUiSideMenuWrappernName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case 'teamSettings':
      _updateData = { teams: glsTeams }
      _pks = seasonalHelpers.getPks(pathViews, null, sportsKey, ['teams'])
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
      break;

    case 'tournamentResults':
      if (tournamentResults) {
        Object.keys(tournamentResults).forEach(trk => {
          const tr = tournamentResults[trk]
          const { name } = tr
          switch (trk) {
            case 'newItem':
              tournamentResults[name] = tr
              delete tournamentResults[trk]
              break;
            default:
            // nothing
          }
        })
      }
      _updateData = { tournaments: tournamentResults }
      _pks = seasonalHelpers.getPks(pathViews, selectedSeason, sportsKey)
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.tournamentResults, _updateProps)
      break;

    case _sdm.sports.teamRosters:
      // _updateData = { ['teamRosters']: current_accessOrGls } 
      if (allRosters && teamRosters) {
        if (parentDataKeys?.teamRosters_seasonal) {
          const _urd = {}
          _.forEach(teamRosters, (tr, tri) => {
            const _team = _.find(teams, { name: _.startCase(tri) })
            if (_team) {
              _urd['teamRosters.' + _team._itemKey] = tr
            }
          })
          _updateData = _urd
        } else {
          const _urd2 = {}
          _.forEach(teamRosters, (tr, tri) => {
            const _team = _.find(teams, { name: _.startCase(tri) })
            if (_team) {
              _urd2[_team._itemKey] = tr
            }
          })
          const _urd3 = {
            teamRosters: {
              ..._urd2
            }
          }
          _updateData = _urd3
        }
      } else {
        _updateData = { ['teamRosters.' + currentMenuKey]: current_accessOrGls }
      }
      _pks = seasonalHelpers.getPks(pathViews, selectedSeason, sportsKey, ['schools', 'teams'])
      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      if (_sportsYearAbr) {
        _updateProps._sportsYearAbr = _sportsYearAbr
        _updateProps.useAddKey = true
      }
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.teamRosters, _updateProps)
      break;

    default:
      switch (sportAccessType) {

        case sportAccessTypes.school:
          _updateData = { schools: current_accessOrGls }
          _pks = seasonalHelpers.getPks(pathViews, null, null, ['schools'])
          break;

        case sportAccessTypes.sport:
          if (sportsMode.school) {
            _updateData = { ['schools.' + pathViews.schools]: current_accessOrGls }
          } else if (sportsMode.district) {
            _updateData = { sports: current_accessOrGls }
          }
          _pks = seasonalHelpers.getPks(pathViews, null, null, ['schools'])
          break;

        case sportAccessTypes.team:
          _updateData = { teams: current_accessOrGls }
          _pks = seasonalHelpers.getPks(pathViews, null, sportsKey, ['teams'])
          break;

        case sportAccessTypes.googleLink:
        case sportAccessTypes.accessLink:
          _updateData = { sports: current_accessOrGls }
          _pks = seasonalHelpers.getPks(pathViews, null, sportsKey, ['teams'])
          break;

        case sportAccessTypes.scoreLink:
          _updateData = { ['sports.' + currentMenuKey]: formData }
          _pks = seasonalHelpers.getPks(pathViews, null, sportsKey, ['teams'])
          break;

        default:
        // notthing

      }

      console.log('_pks', _pks)

      seasonalHelpers.ammend_updateProps(_updateProps, _pks, cb)
      seasonalHelpers.ammend_updateNameProps(_updateProps, collectionName, null, _updateData)
      _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.sportsAccess, _updateProps)
  }
}

const saveGlsDataToDatabase = (database_fns, pathViews, state, action, callback) => {

  const _seasonalDataHelpers = seasonalDataHelpers(database_fns, pathViews)

  const { data } = action
  const { collectionName, sportPermissions } = state
  const options = {
    ignoreSeason: true
  }

  const cb = () => callback()

  let _pks = seasonalHelpers.getPks(pathViews)

  const _updateData = {
    [collectionName]: data
  }

  if (collectionName && _updateData) {
    const _updateProps = _seasonalDataHelpers.getUpdateProps(sportPermissions, _pks, cb, collectionName, null, _updateData, options)
    _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.teamRosters, _updateProps)
  }

}

const saveSettingsData = (database_fns, pathViews, state, action, callback) => {

  const _seasonalDataHelpers = seasonalDataHelpers(database_fns, pathViews)

  const { sheetType, data, currentMenuKey } = action
  const { selectedSeason, sportsKey, collectionName, sportPermissions } = state

  const cb = () => callback()

  let _collectionName;
  let _updateData;
  let _pks = seasonalHelpers.getPks(pathViews, selectedSeason, sportsKey, ['teams'])
  const options = {}

  switch (sheetType) {
    case _sportsFormProps.glsTeam.rosterSheet:
      _collectionName = 'teamRosters'
      _updateData = {
        [_collectionName]: {
          [currentMenuKey]: data
        }
      }
      break;
    case _sportsFormProps.glsTeam.staffSheet:
      _collectionName = 'teamStaff'
      _updateData = {
        [_collectionName]: {
          [currentMenuKey]: data
        }
      }
      break;
    default:
      _collectionName = collectionName
      _updateData = {
        [_collectionName]: data
      }
      options.ignoreSeason = true
    // nothing 
  }

  if (collectionName && _updateData) {
    const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, _pks, cb, collectionName, null, _updateData, options)
    _seasonalDataHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.teamRosters, _updateProps)
  }

}



export const sportsDataHelpers = (database_fns, pathViews) => ({
  saveSportsDataToDatabase: (state, callback, allRosters) => saveSportsDataToDatabase(database_fns, pathViews, state, callback, allRosters),
  saveGlsDataToDatabase: (state, action, callback) => saveGlsDataToDatabase(database_fns, pathViews, state, action, callback),
  saveSettingsData: (state, action, callback) => saveSettingsData(database_fns, pathViews, state, action, callback),
})